import { render, staticRenderFns } from "./NewCase.vue?vue&type=template&id=30db9356&"
import script from "./NewCase.vue?vue&type=script&lang=js&"
export * from "./NewCase.vue?vue&type=script&lang=js&"
import style0 from "./NewCase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports